const nesRadiusSm = "3px";
const nesRadiusMd = "6px";
const nesRadiusLg = "12px";
const nesRadiusFull = "9999px";
const nesColorYellow950 = "rgb(41, 37, 15)";
const nesColorYellow900 = "rgb(105, 69, 4)";
const nesColorYellow800 = "rgb(141, 105, 0)";
const nesColorYellow700 = "rgb(163, 127, 12)";
const nesColorYellow600 = "rgb(218, 157, 0)";
const nesColorYellow500 = "rgb(255, 181, 25)";
const nesColorYellow = "rgb(255, 201, 23)";
const nesColorYellow300 = "rgb(255, 211, 97)";
const nesColorYellow200 = "rgb(255, 227, 132)";
const nesColorYellow100 = "rgb(253, 242, 202)";
const nesColorYellow50 = "rgb(251, 245, 231)";
const nesColorBlue950 = "rgb(29, 37, 60)";
const nesColorBlue900 = "rgb(0, 33, 89)";
const nesColorBlue = "rgb(0, 48, 130)";
const nesColorBlue700 = "rgb(23, 67, 139)";
const nesColorBlue600 = "rgb(40, 84, 156)";
const nesColorBlue500 = "rgb(65, 112, 190)";
const nesColorBlue400 = "rgb(124, 167, 227)";
const nesColorBlue300 = "rgb(171, 202, 239)";
const nesColorBlue200 = "rgb(202, 219, 241)";
const nesColorBlue100 = "rgb(226, 236, 251)";
const nesColorBlue50 = "rgb(239, 244, 252)";
const nesColorLightBlue950 = "rgb(22, 36, 62)";
const nesColorLightBlue900 = "rgb(15, 55, 101)";
const nesColorLightBlue800 = "rgb(12, 72, 141)";
const nesColorLightBlue700 = "rgb(0, 77, 197)";
const nesColorLightBlue = "rgb(0, 99, 211)";
const nesColorLightBlue500 = "rgb(40, 133, 239)";
const nesColorLightBlue400 = "rgb(82, 155, 237)";
const nesColorLightBlue300 = "rgb(150, 199, 250)";
const nesColorLightBlue200 = "rgb(193, 220, 252)";
const nesColorLightBlue100 = "rgb(219, 235, 253)";
const nesColorLightBlue50 = "rgb(235, 245, 255)";
const nesColorGreen950 = "rgb(20, 42, 41)";
const nesColorGreen900 = "rgb(38, 77, 74)";
const nesColorGreen800 = "rgb(45, 93, 89)";
const nesColorGreen700 = "rgb(0, 112, 96)";
const nesColorGreen600 = "rgb(0, 134, 112)";
const nesColorGreen = "rgb(0, 168, 136)";
const nesColorGreen400 = "rgb(0, 198, 144)";
const nesColorGreen300 = "rgb(123, 229, 185)";
const nesColorGreen200 = "rgb(173, 242, 209)";
const nesColorGreen100 = "rgb(212, 249, 230)";
const nesColorGreen50 = "rgb(234, 250, 244)";
const nesColorRed950 = "rgb(54, 24, 28)";
const nesColorRed900 = "rgb(103, 0, 0)";
const nesColorRed800 = "rgb(139, 12, 35)";
const nesColorRed700 = "rgb(186, 34, 61)";
const nesColorRed600 = "rgb(219, 0, 64)";
const nesColorRed = "rgb(236, 0, 69)";
const nesColorRed400 = "rgb(242, 113, 116)";
const nesColorRed300 = "rgb(248, 165, 166)";
const nesColorRed200 = "rgb(251, 202, 203)";
const nesColorRed100 = "rgb(252, 226, 226)";
const nesColorRed50 = "rgb(253, 242, 242)";
const nesColorOrange950 = "rgb(49, 30, 22)";
const nesColorOrange900 = "rgb(114, 50, 30)";
const nesColorOrange800 = "rgb(141, 59, 36)";
const nesColorOrange700 = "rgb(189, 76, 13)";
const nesColorOrange600 = "rgb(238, 96, 0)";
const nesColorOrange = "rgb(254, 98, 0)";
const nesColorOrange400 = "rgb(251, 139, 53)";
const nesColorOrange300 = "rgb(255, 178, 105)";
const nesColorOrange200 = "rgb(247, 215, 178)";
const nesColorOrange100 = "rgb(251, 237, 217)";
const nesColorOrange50 = "rgb(254, 246, 238)";
const nesColorPurple950 = "rgb(40, 31, 59)";
const nesColorPurple900 = "rgb(60, 30, 125)";
const nesColorPurple800 = "rgb(79, 47, 150)";
const nesColorPurple700 = "rgb(95, 72, 169)";
const nesColorPurple = "rgb(108, 89, 177)";
const nesColorPurple500 = "rgb(149, 107, 218)";
const nesColorPurple400 = "rgb(176, 141, 239)";
const nesColorPurple300 = "rgb(176, 141, 239)";
const nesColorPurple200 = "rgb(229, 215, 251)";
const nesColorPurple100 = "rgb(241, 233, 252)";
const nesColorPurple50 = "rgb(245, 239, 248)";
const nesColorPink950 = "rgb(59, 19, 38)";
const nesColorPink900 = "rgb(130, 27, 67)";
const nesColorPink800 = "rgb(155, 27, 78)";
const nesColorPink700 = "rgb(188, 30, 94)";
const nesColorPink = "rgb(217, 45, 119)";
const nesColorPink500 = "rgb(234, 76, 153)";
const nesColorPink400 = "rgb(242, 117, 181)";
const nesColorPink300 = "rgb(247, 169, 211)";
const nesColorPink200 = "rgb(250, 208, 232)";
const nesColorPink100 = "rgb(252, 231, 243)";
const nesColorPink50 = "rgb(253, 242, 248)";
const nesColorBlack = "rgb(0, 0, 0)";
const nesColorGray950 = "rgb(11, 12, 14)";
const nesColorGray900 = "rgb(17, 18, 20)";
const nesColorGray800 = "rgb(37, 37, 40)";
const nesColorGray700 = "rgb(51, 52, 56)";
const nesColorGray600 = "rgb(64, 65, 68)";
const nesColorGray500 = "rgb(117, 118, 124)";
const nesColorGray400 = "rgb(147, 148, 154)";
const nesColorGray300 = "rgb(196, 197, 203)";
const nesColorGray200 = "rgb(214, 215, 220)";
const nesColorGray100 = "rgb(228, 229, 232)";
const nesColorGray75 = "rgb(234, 235, 238)";
const nesColorGray50 = "rgb(240, 241, 243)";
const nesColorGray25 = "rgb(247, 247, 249)";
const nesColorWhite = "rgb(255, 255, 255)";
const nesColorTextDefault = "rgb(0, 48, 130)";
const nesColorTextHeading = "rgb(0, 48, 130)";
const nesColorTextBody = "rgb(37, 37, 40)";
const nesColorTextSubtle = "rgb(117, 118, 124)";
const nesColorTextGhost = "rgb(147, 148, 154)";
const nesColorTextAlpha = "rgba(0, 1, 13, 0.54)";
const nesColorTextLight = "rgb(255, 255, 255)";
const nesColorTextBrandPrimary = "rgb(255, 201, 23)";
const nesColorTextBrandSecondary = "rgb(0, 48, 130)";
const nesColorTextBrandSecondaryStrong = "rgb(0, 33, 89)";
const nesColorTextBrandNsGo = "rgb(0, 198, 144)";
const nesColorTextInfo = "rgb(0, 99, 211)";
const nesColorTextInfoContrast = "rgb(0, 77, 197)";
const nesColorTextInfoStrong = "rgb(12, 72, 141)";
const nesColorTextSuccess = "rgb(0, 168, 136)";
const nesColorTextSuccessContrast = "rgb(0, 134, 112)";
const nesColorTextSuccessStrong = "rgb(0, 112, 96)";
const nesColorTextWarning = "rgb(254, 98, 0)";
const nesColorTextWarningContrast = "rgb(238, 96, 0)";
const nesColorTextWarningStrong = "rgb(189, 76, 13)";
const nesColorTextAlert = "rgb(236, 0, 69)";
const nesColorTextAlertContrast = "rgb(219, 0, 64)";
const nesColorTextAlertStrong = "rgb(186, 34, 61)";
const nesColorTextHighlight = "rgb(108, 89, 177)";
const nesColorTextHighlightContrast = "rgb(95, 72, 169)";
const nesColorTextHighlightStrong = "rgb(79, 47, 150)";
const nesColorTextCtaDefault = "rgb(0, 99, 211)";
const nesColorTextCtaPressed = "rgb(0, 48, 130)";
const nesColorTextCtaVisited = "rgb(108, 89, 177)";
const nesColorTextCtaLight = "rgb(255, 255, 255)";
const nesColorBgDefault = "rgb(255, 255, 255)";
const nesColorBgElevated = "rgb(255, 255, 255)";
const nesColorBgElevatedPressed = "rgb(240, 241, 243)";
const nesColorBgElevatedAlt = "rgb(255, 255, 255)";
const nesColorBgElevatedTransparent = "rgba(255, 255, 255, 0)";
const nesColorBgTintPrimaryPale = "rgb(247, 247, 249)";
const nesColorBgTintPrimary = "rgb(240, 241, 243)";
const nesColorBgTintPrimaryMedium = "rgb(234, 235, 238)";
const nesColorBgTintPrimaryStrong = "rgb(228, 229, 232)";
const nesColorBgTintSecondary = "rgb(235, 245, 255)";
const nesColorBgTintSecondaryAccent = "rgb(235, 245, 255)";
const nesColorBgTintInfo = "rgb(235, 245, 255)";
const nesColorBgTintSuccess = "rgb(234, 250, 244)";
const nesColorBgTintOffer = "rgb(234, 250, 244)";
const nesColorBgTintWarning = "rgb(254, 246, 238)";
const nesColorBgTintAlert = "rgb(253, 242, 242)";
const nesColorBgTintHighlight = "rgb(245, 239, 248)";
const nesColorBgAlphaPale = "rgba(0, 0, 41, 0.03)";
const nesColorBgAlphaSubtle = "rgba(0, 16, 47, 0.06)";
const nesColorBgAlphaMedium = "rgba(0, 9, 47, 0.08)";
const nesColorBgAlphaStrong = "rgba(6, 15, 46, 0.11)";
const nesColorBgBrandPrimary = "rgb(255, 201, 23)";
const nesColorBgBrandPrimaryAlt = "rgb(255, 201, 23)";
const nesColorBgBrandSecondary = "rgb(0, 48, 130)";
const nesColorBgBrandSecondaryStrong = "rgb(0, 33, 89)";
const nesColorBgBrandNsGo = "rgb(0, 198, 144)";
const nesColorBgInfo = "rgb(0, 99, 211)";
const nesColorBgSuccess = "rgb(0, 168, 136)";
const nesColorBgSuccessContrast = "rgb(0, 134, 112)";
const nesColorBgWarning = "rgb(254, 98, 0)";
const nesColorBgWarningContrast = "rgb(238, 96, 0)";
const nesColorBgAlert = "rgb(236, 0, 69)";
const nesColorBgAlertContrast = "rgb(219, 0, 64)";
const nesColorBgHighlight = "rgb(108, 89, 177)";
const nesColorBgHighlightContrast = "rgb(95, 72, 169)";
const nesColorBgCtaDefault = "rgb(0, 99, 211)";
const nesColorBgCtaPressed = "rgb(0, 48, 130)";
const nesColorBorderDefault = "rgb(228, 229, 232)";
const nesColorBorderDefaultAlt = "rgb(228, 229, 232)";
const nesColorBorderSubtle = "rgb(234, 235, 238)";
const nesColorBorderLight = "rgb(255, 255, 255)";
const nesColorBorderStrong = "rgb(196, 197, 203)";
const nesColorBorderAlpha = "rgba(6, 15, 46, 0.11)";
const nesColorBorderAlphaAlt = "rgba(6, 15, 46, 0.11)";
const nesColorBorderAlphaSubtle = "rgba(0, 9, 47, 0.08)";
const nesColorBorderBrandPrimary = "rgb(255, 201, 23)";
const nesColorBorderBrandSecondary = "rgb(0, 48, 130)";
const nesColorBorderBrandSecondaryStrong = "rgb(0, 33, 89)";
const nesColorBorderBrandNsGo = "rgb(0, 198, 144)";
const nesColorBorderInfo = "rgb(0, 99, 211)";
const nesColorBorderSuccess = "rgb(0, 168, 136)";
const nesColorBorderWarning = "rgb(254, 98, 0)";
const nesColorBorderAlert = "rgb(236, 0, 69)";
const nesColorFormLabel = "rgb(0, 48, 130)";
const nesColorFormBg = "rgb(255, 255, 255)";
const nesColorFormVal = "rgb(37, 37, 40)";
const nesColorFormValChecked = "rgb(0, 48, 130)";
const nesColorFormPlaceholder = "rgb(147, 148, 154)";
const nesColorFormHelptext = "rgba(0, 1, 13, 0.54)";
const nesColorFormChecked = "rgb(0, 168, 136)";
const nesColorFormBorder = "rgb(196, 197, 203)";
const nesColorFormBorderPressed = "rgb(147, 148, 154)";
const nesColorFormError = "rgb(236, 0, 69)";
const nesColorFormIcon = "rgb(0, 48, 130)";
const nesColorDestructiveDefault = "rgb(236, 0, 69)";
const nesColorDestructivePressed = "rgb(219, 0, 64)";
const nesColorFocusDefault = "rgb(0, 99, 211)";
const nesColorFocusPressed = "rgb(0, 48, 130)";
const nesColorFocusLight = "rgb(255, 255, 255)";
const nesColorButtonBrandText = "rgb(0, 48, 130)";
const nesColorButtonBrandBg = "rgb(255, 201, 23)";
const nesColorButtonBrandBgPressed = "rgb(255, 181, 25)";
const nesColorButtonBrandFocus = "rgb(0, 99, 211)";
const nesColorButtonPrimaryText = "rgb(255, 255, 255)";
const nesColorButtonPrimaryBg = "rgb(0, 99, 211)";
const nesColorButtonPrimaryBgPressed = "rgb(0, 77, 197)";
const nesColorButtonPrimaryInvertedText = "rgb(0, 99, 211)";
const nesColorButtonPrimaryInvertedBg = "rgb(255, 255, 255)";
const nesColorButtonPrimaryInvertedBgPressed = "rgb(228, 229, 232)";
const nesColorButtonSecondaryText = "rgb(0, 48, 130)";
const nesColorButtonSecondaryBg = "rgba(0, 16, 47, 0.06)";
const nesColorButtonSecondaryBgPressed = "rgba(0, 9, 47, 0.08)";
const nesColorButtonSecondaryInvertedText = "rgb(255, 255, 255)";
const nesColorButtonSecondaryInvertedBg = "rgba(255, 255, 255, 0.09)";
const nesColorButtonSecondaryInvertedBgPressed = "rgba(255, 255, 255, 0.12)";
const nesColorButtonTertiaryText = "rgb(0, 99, 211)";
const nesColorButtonTertiaryTextPressed = "rgb(0, 48, 130)";
const nesColorButtonTertiaryBgPressed = "rgba(0, 16, 47, 0.06)";
const nesColorButtonTertiaryInvertedText = "rgb(255, 255, 255)";
const nesColorButtonTertiaryInvertedBgPressed = "rgba(255, 255, 255, 0.06)";
const nesColorRadioPanelBg = "rgba(0, 9, 47, 0.08)";
const nesColorRadioPanelBgChecked = "rgb(255, 255, 255)";
const nesColorStickerDefaultText = "rgb(0, 48, 130)";
const nesColorStickerDefaultBorder = "rgba(6, 15, 46, 0.11)";
const nesColorStickerDefaultFilledText = "rgb(255, 255, 255)";
const nesColorStickerDefaultFilledBg = "rgb(0, 48, 130)";
const nesColorStickerBrandText = "rgb(0, 48, 130)";
const nesColorStickerBrandBorder = "rgb(255, 201, 23)";
const nesColorStickerBrandFilledText = "rgb(0, 48, 130)";
const nesColorStickerBrandFilledBg = "rgb(255, 201, 23)";
const nesColorStickerSubtleText = "rgb(117, 118, 124)";
const nesColorStickerSubtleBorder = "rgb(228, 229, 232)";
const nesColorStickerSubtleFilledText = "rgb(255, 255, 255)";
const nesColorStickerSubtleFilledBg = "rgb(117, 118, 124)";
const nesColorStickerHighlightText = "rgb(108, 89, 177)";
const nesColorStickerHighlightBg = "rgb(245, 239, 248)";
const nesColorStickerHighlightFilledText = "rgb(255, 255, 255)";
const nesColorStickerHighlightFilledBg = "rgb(108, 89, 177)";
const nesColorStickerOfferText = "rgb(0, 112, 96)";
const nesColorStickerOfferBg = "rgb(234, 250, 244)";
const nesColorStickerOfferFilledText = "rgb(255, 255, 255)";
const nesColorStickerOfferFilledBg = "rgb(0, 134, 112)";
const nesColorToggleBg = "rgba(6, 15, 46, 0.11)";
const nesColorToggleKnobBg = "rgb(255, 255, 255)";
const nesColorHeroTextDark = "rgb(0, 48, 130)";
const nesColorHeroTextShadowLight = "rgba(255, 255, 255, 0.5)";
const nesColorHeroFlowLight = "rgb(255, 255, 255)";
const nesColorHeroFlowDark = "rgb(0, 48, 130)";
const nesColorMessageText = "rgb(37, 37, 40)";
const nesColorMessageInlineBorder = "rgb(228, 229, 232)";
const nesColorMessageToastBg = "rgb(0, 48, 130)";
const nesColorMessageToastErrorBg = "rgb(236, 0, 69)";
const nesColorBadgeDefaultBg = "rgb(0, 48, 130)";
const nesColorBadgeDefaultText = "rgb(255, 255, 255)";
const nesColorBadgeBrandBg = "rgb(255, 201, 23)";
const nesColorBadgeBrandText = "rgb(0, 48, 130)";
const nesColorBadgeAlertBg = "rgb(236, 0, 69)";
const nesColorBadgeAlertText = "rgb(255, 255, 255)";
const nesColorBadgeSubtleBg = "rgba(6, 15, 46, 0.11)";
const nesColorBadgeSubtleText = "rgb(0, 48, 130)";
const nesColorBadgeSubtleInvertedBg = "rgb(255, 255, 255)";
const nesColorBadgeSubtleInvertedText = "rgb(0, 48, 130)";
const nesColorBadgeSuccessBg = "rgb(0, 168, 136)";
const nesColorBadgeSuccessText = "rgb(255, 255, 255)";
const nesColorTooltipBg = "rgb(51, 52, 56)";
const nesColorTooltipText = "rgb(255, 255, 255)";
const nesColorChipcardInputBorderPressed = "rgb(147, 148, 154)";
const nesColorListItemIcon = "rgb(0, 48, 130)";
const nesColorLogoDefault = "rgb(0, 48, 130)";
const nesColorLogoLight = "rgb(255, 255, 255)";
const nesColorExpandableText = "rgb(0, 99, 211)";
const nesColorExpandableTextPressed = "rgb(0, 48, 130)";
const nesColorExpandableBorder = "rgb(228, 229, 232)";
const nesColorExpandableInvertedText = "rgb(255, 255, 255)";
const nesColorExpandableInvertedTextPressed = "rgb(255, 255, 255)";
const nesColorExpandableInvertedBorder = "rgba(255, 255, 255, 0.12)";
const nesColorFeatureTipBg = "rgb(108, 89, 177)";
const nesColorTextListItemPrimary = "rgb(0, 99, 211)";
const nesColorBottomSheetBg = "rgb(255, 255, 255)";
const nesColorHighlightBoxDefaultBg = "rgb(245, 239, 248)";
const nesColorHighlightBoxDefaultText = "rgb(95, 72, 169)";
const nesColorHighlightBoxOfferBg = "rgb(234, 250, 244)";
const nesColorHighlightBoxOfferText = "rgb(0, 112, 96)";
const nesColorHighlightBoxInfoBg = "rgb(235, 245, 255)";
const nesColorHighlightBoxInfoText = "rgb(0, 48, 130)";
const nesColorHighlightBoxBrandBg = "rgb(251, 245, 231)";
const nesColorHighlightBoxBrandText = "rgb(141, 105, 0)";
const nesColorRangeSliderBg = "rgba(6, 15, 46, 0.11)";
const nesColorRangeSliderBgPressed = "rgba(0, 6, 33, 0.16)";
const nesColorRangeSliderFill = "rgb(0, 48, 130)";
const nesColorRangeSliderMinmax = "rgba(0, 1, 13, 0.54)";
const nesColorRangeSliderKnobBg = "rgb(255, 255, 255)";
const nesColorRangeSliderKnobBorder = "rgb(196, 197, 203)";
const nesColorRangeSliderKnobBorderPressed = "rgb(147, 148, 154)";
const nesAlphaWhite0 = "rgba(255, 255, 255, 0)";
const nesAlphaWhite50 = "rgba(255, 255, 255, 0.06)";
const nesAlphaWhite75 = "rgba(255, 255, 255, 0.09)";
const nesAlphaWhite100 = "rgba(255, 255, 255, 0.12)";
const nesAlphaWhite200 = "rgba(242, 242, 250, 0.21)";
const nesAlphaWhite500 = "rgba(255, 255, 255, 0.5)";
const nesAlphaBlack25 = "rgba(0, 0, 41, 0.03)";
const nesAlphaBlack50 = "rgba(0, 16, 47, 0.06)";
const nesAlphaBlack75 = "rgba(0, 9, 47, 0.08)";
const nesAlphaBlack100 = "rgba(6, 15, 46, 0.11)";
const nesAlphaBlack200 = "rgba(0, 6, 33, 0.16)";
const nesAlphaBlack300 = "rgba(0, 2, 27, 0.23)";
const nesAlphaBlack400 = "rgba(0, 1, 15, 0.42)";
const nesAlphaBlack500 = "rgba(0, 1, 13, 0.54)";
const nesSpacing1 = "4px";
const nesSpacing2 = "8px";
const nesSpacing3 = "12px";
const nesSpacing4 = "16px";
const nesSpacing5 = "20px";
const nesSpacing6 = "24px";
const nesSpacing8 = "32px";
const nesSpacing10 = "40px";
const nesSpacing12 = "48px";
const nesSpacing14 = "56px";
const nesSpacing16 = "64px";
const nesSpacing20 = "80px";
const nesSpacing24 = "96px";
const nesSpacing32 = "128px";
const nesBreakpointSm = "480px";
const nesBreakpointMd = "740px";
const nesBreakpointLg = "980px";
const nesBreakpointXl = "1300px";
const nesMotionEaseDefault = "cubic-bezier(0.2, 0.9, 0.4, 1)";
const nesMotionEaseIn = "cubic-bezier(1, 0.4, 0.9, 0.2)";
const nesMotionEaseOut = "cubic-bezier(0.2, 0.9, 0.4, 1)";
const nesMotionEaseInOut = "cubic-bezier(0.7, 0.27, 0.27, 1)";
const nesMotionEaseInOutExpo = "cubic-bezier(1, 0, 0, 1)";
const nesMotionDurationXs = "200ms";
const nesMotionDurationDefault = "300ms";
const nesMotionDurationMd = "400ms";
const nesMotionDurationLg = "500ms";
const nesMotionDurationXl = "700ms";
const nesMotionDuration2xl = "1000ms";
const nesMotionDuration3xl = "1500ms";
const nesShadowWebSm = "0 2px 4px rgba(0, 0, 0, 0.03), 0 4px 8px rgba(0, 0, 0, 0.03), 0 8px 16px rgba(0, 0, 0, 0.03)";
const nesShadowWebMd = "0 0 8px rgba(0, 0, 0, 0.05), 0 4px 16px rgba(0, 0, 0, 0.05), 0 8px 32px rgba(0, 0, 0, 0.05)";
const nesShadowWebLg = "0 4px 12px rgba(0, 0, 0, 0.05), 0 8px 24px rgba(0, 0, 0, 0.05), 0 16px 48px rgba(0, 0, 0, 0.05)";
const nesShadowWebNavbar = "0 1px 1px rgba(0, 0, 0, 0.03), 0 10px 20px rgba(0, 0, 0, 0.04)";
const nesShadowWebText = "0 0 48px rgba(0, 0, 0, 0.15), 1px 1px 0 rgba(0, 0, 0, 0.3)";
const nesShadowIosSmColor = "#000";
const nesShadowIosSmOffsetWidth = "0";
const nesShadowIosSmOffsetHeight = "4";
const nesShadowIosSmOpacity = "0.1";
const nesShadowIosSmRadius = "10";
const nesShadowIosMdColor = "#000";
const nesShadowIosMdOffsetWidth = "0";
const nesShadowIosMdOffsetHeight = "4";
const nesShadowIosMdOpacity = "0.15";
const nesShadowIosMdRadius = "15";
const nesShadowIosLgColor = "#000";
const nesShadowIosLgOffsetWidth = "0";
const nesShadowIosLgOffsetHeight = "4";
const nesShadowIosLgOpacity = "0.2";
const nesShadowIosLgRadius = "20";
const nesShadowAndroidSmElevation = "4";
const nesShadowAndroidMdElevation = "8";
const nesShadowAndroidLgElevation = "12";
const nesFontFamily = "'NS Sans'";
const nesFontSize2xs = "0.625rem";
const nesFontSizeXs = "0.75rem";
const nesFontSizeSm = "0.875rem";
const nesFontSizeBase = "1rem";
const nesFontSizeLg = "1.125rem";
const nesFontSizeXl = "1.25rem";
const nesFontSize2xl = "1.375rem";
const nesFontSize3xl = "1.5rem";
const nesFontSize4xl = "1.75rem";
const nesFontSize5xl = "2rem";
const nesFontSize6xl = "2.25rem";
const nesFontSize7xl = "2.5rem";
const nesFontSize8xl = "3rem";
const nesFontSize9xl = "4rem";
const nesFontSize10xl = "5rem";
const nesFontWeightNormal = "400";
const nesFontWeightDemi = "550";
const nesFontWeightBold = "700";
const nesFontStyleNormal = "normal";
const nesFontStyleItalic = "italic";
const nesFontLeadingNone = "1";
const nesFontLeadingCompressed = "1.125";
const nesFontLeadingTight = "1.25";
const nesFontLeadingNormal = "1.5";
const nesFontLeadingRelaxed = "1.625";
const nesFontLeadingLoose = "2";
const nesFontTrackingNormal = "0";
const nesFontTrackingTight = "-0.016em";
const tokens = {
	nesRadiusSm: nesRadiusSm,
	nesRadiusMd: nesRadiusMd,
	nesRadiusLg: nesRadiusLg,
	nesRadiusFull: nesRadiusFull,
	nesColorYellow950: nesColorYellow950,
	nesColorYellow900: nesColorYellow900,
	nesColorYellow800: nesColorYellow800,
	nesColorYellow700: nesColorYellow700,
	nesColorYellow600: nesColorYellow600,
	nesColorYellow500: nesColorYellow500,
	nesColorYellow: nesColorYellow,
	nesColorYellow300: nesColorYellow300,
	nesColorYellow200: nesColorYellow200,
	nesColorYellow100: nesColorYellow100,
	nesColorYellow50: nesColorYellow50,
	nesColorBlue950: nesColorBlue950,
	nesColorBlue900: nesColorBlue900,
	nesColorBlue: nesColorBlue,
	nesColorBlue700: nesColorBlue700,
	nesColorBlue600: nesColorBlue600,
	nesColorBlue500: nesColorBlue500,
	nesColorBlue400: nesColorBlue400,
	nesColorBlue300: nesColorBlue300,
	nesColorBlue200: nesColorBlue200,
	nesColorBlue100: nesColorBlue100,
	nesColorBlue50: nesColorBlue50,
	nesColorLightBlue950: nesColorLightBlue950,
	nesColorLightBlue900: nesColorLightBlue900,
	nesColorLightBlue800: nesColorLightBlue800,
	nesColorLightBlue700: nesColorLightBlue700,
	nesColorLightBlue: nesColorLightBlue,
	nesColorLightBlue500: nesColorLightBlue500,
	nesColorLightBlue400: nesColorLightBlue400,
	nesColorLightBlue300: nesColorLightBlue300,
	nesColorLightBlue200: nesColorLightBlue200,
	nesColorLightBlue100: nesColorLightBlue100,
	nesColorLightBlue50: nesColorLightBlue50,
	nesColorGreen950: nesColorGreen950,
	nesColorGreen900: nesColorGreen900,
	nesColorGreen800: nesColorGreen800,
	nesColorGreen700: nesColorGreen700,
	nesColorGreen600: nesColorGreen600,
	nesColorGreen: nesColorGreen,
	nesColorGreen400: nesColorGreen400,
	nesColorGreen300: nesColorGreen300,
	nesColorGreen200: nesColorGreen200,
	nesColorGreen100: nesColorGreen100,
	nesColorGreen50: nesColorGreen50,
	nesColorRed950: nesColorRed950,
	nesColorRed900: nesColorRed900,
	nesColorRed800: nesColorRed800,
	nesColorRed700: nesColorRed700,
	nesColorRed600: nesColorRed600,
	nesColorRed: nesColorRed,
	nesColorRed400: nesColorRed400,
	nesColorRed300: nesColorRed300,
	nesColorRed200: nesColorRed200,
	nesColorRed100: nesColorRed100,
	nesColorRed50: nesColorRed50,
	nesColorOrange950: nesColorOrange950,
	nesColorOrange900: nesColorOrange900,
	nesColorOrange800: nesColorOrange800,
	nesColorOrange700: nesColorOrange700,
	nesColorOrange600: nesColorOrange600,
	nesColorOrange: nesColorOrange,
	nesColorOrange400: nesColorOrange400,
	nesColorOrange300: nesColorOrange300,
	nesColorOrange200: nesColorOrange200,
	nesColorOrange100: nesColorOrange100,
	nesColorOrange50: nesColorOrange50,
	nesColorPurple950: nesColorPurple950,
	nesColorPurple900: nesColorPurple900,
	nesColorPurple800: nesColorPurple800,
	nesColorPurple700: nesColorPurple700,
	nesColorPurple: nesColorPurple,
	nesColorPurple500: nesColorPurple500,
	nesColorPurple400: nesColorPurple400,
	nesColorPurple300: nesColorPurple300,
	nesColorPurple200: nesColorPurple200,
	nesColorPurple100: nesColorPurple100,
	nesColorPurple50: nesColorPurple50,
	nesColorPink950: nesColorPink950,
	nesColorPink900: nesColorPink900,
	nesColorPink800: nesColorPink800,
	nesColorPink700: nesColorPink700,
	nesColorPink: nesColorPink,
	nesColorPink500: nesColorPink500,
	nesColorPink400: nesColorPink400,
	nesColorPink300: nesColorPink300,
	nesColorPink200: nesColorPink200,
	nesColorPink100: nesColorPink100,
	nesColorPink50: nesColorPink50,
	nesColorBlack: nesColorBlack,
	nesColorGray950: nesColorGray950,
	nesColorGray900: nesColorGray900,
	nesColorGray800: nesColorGray800,
	nesColorGray700: nesColorGray700,
	nesColorGray600: nesColorGray600,
	nesColorGray500: nesColorGray500,
	nesColorGray400: nesColorGray400,
	nesColorGray300: nesColorGray300,
	nesColorGray200: nesColorGray200,
	nesColorGray100: nesColorGray100,
	nesColorGray75: nesColorGray75,
	nesColorGray50: nesColorGray50,
	nesColorGray25: nesColorGray25,
	nesColorWhite: nesColorWhite,
	nesColorTextDefault: nesColorTextDefault,
	nesColorTextHeading: nesColorTextHeading,
	nesColorTextBody: nesColorTextBody,
	nesColorTextSubtle: nesColorTextSubtle,
	nesColorTextGhost: nesColorTextGhost,
	nesColorTextAlpha: nesColorTextAlpha,
	nesColorTextLight: nesColorTextLight,
	nesColorTextBrandPrimary: nesColorTextBrandPrimary,
	nesColorTextBrandSecondary: nesColorTextBrandSecondary,
	nesColorTextBrandSecondaryStrong: nesColorTextBrandSecondaryStrong,
	nesColorTextBrandNsGo: nesColorTextBrandNsGo,
	nesColorTextInfo: nesColorTextInfo,
	nesColorTextInfoContrast: nesColorTextInfoContrast,
	nesColorTextInfoStrong: nesColorTextInfoStrong,
	nesColorTextSuccess: nesColorTextSuccess,
	nesColorTextSuccessContrast: nesColorTextSuccessContrast,
	nesColorTextSuccessStrong: nesColorTextSuccessStrong,
	nesColorTextWarning: nesColorTextWarning,
	nesColorTextWarningContrast: nesColorTextWarningContrast,
	nesColorTextWarningStrong: nesColorTextWarningStrong,
	nesColorTextAlert: nesColorTextAlert,
	nesColorTextAlertContrast: nesColorTextAlertContrast,
	nesColorTextAlertStrong: nesColorTextAlertStrong,
	nesColorTextHighlight: nesColorTextHighlight,
	nesColorTextHighlightContrast: nesColorTextHighlightContrast,
	nesColorTextHighlightStrong: nesColorTextHighlightStrong,
	nesColorTextCtaDefault: nesColorTextCtaDefault,
	nesColorTextCtaPressed: nesColorTextCtaPressed,
	nesColorTextCtaVisited: nesColorTextCtaVisited,
	nesColorTextCtaLight: nesColorTextCtaLight,
	nesColorBgDefault: nesColorBgDefault,
	nesColorBgElevated: nesColorBgElevated,
	nesColorBgElevatedPressed: nesColorBgElevatedPressed,
	nesColorBgElevatedAlt: nesColorBgElevatedAlt,
	nesColorBgElevatedTransparent: nesColorBgElevatedTransparent,
	nesColorBgTintPrimaryPale: nesColorBgTintPrimaryPale,
	nesColorBgTintPrimary: nesColorBgTintPrimary,
	nesColorBgTintPrimaryMedium: nesColorBgTintPrimaryMedium,
	nesColorBgTintPrimaryStrong: nesColorBgTintPrimaryStrong,
	nesColorBgTintSecondary: nesColorBgTintSecondary,
	nesColorBgTintSecondaryAccent: nesColorBgTintSecondaryAccent,
	nesColorBgTintInfo: nesColorBgTintInfo,
	nesColorBgTintSuccess: nesColorBgTintSuccess,
	nesColorBgTintOffer: nesColorBgTintOffer,
	nesColorBgTintWarning: nesColorBgTintWarning,
	nesColorBgTintAlert: nesColorBgTintAlert,
	nesColorBgTintHighlight: nesColorBgTintHighlight,
	nesColorBgAlphaPale: nesColorBgAlphaPale,
	nesColorBgAlphaSubtle: nesColorBgAlphaSubtle,
	nesColorBgAlphaMedium: nesColorBgAlphaMedium,
	nesColorBgAlphaStrong: nesColorBgAlphaStrong,
	nesColorBgBrandPrimary: nesColorBgBrandPrimary,
	nesColorBgBrandPrimaryAlt: nesColorBgBrandPrimaryAlt,
	nesColorBgBrandSecondary: nesColorBgBrandSecondary,
	nesColorBgBrandSecondaryStrong: nesColorBgBrandSecondaryStrong,
	nesColorBgBrandNsGo: nesColorBgBrandNsGo,
	nesColorBgInfo: nesColorBgInfo,
	nesColorBgSuccess: nesColorBgSuccess,
	nesColorBgSuccessContrast: nesColorBgSuccessContrast,
	nesColorBgWarning: nesColorBgWarning,
	nesColorBgWarningContrast: nesColorBgWarningContrast,
	nesColorBgAlert: nesColorBgAlert,
	nesColorBgAlertContrast: nesColorBgAlertContrast,
	nesColorBgHighlight: nesColorBgHighlight,
	nesColorBgHighlightContrast: nesColorBgHighlightContrast,
	nesColorBgCtaDefault: nesColorBgCtaDefault,
	nesColorBgCtaPressed: nesColorBgCtaPressed,
	nesColorBorderDefault: nesColorBorderDefault,
	nesColorBorderDefaultAlt: nesColorBorderDefaultAlt,
	nesColorBorderSubtle: nesColorBorderSubtle,
	nesColorBorderLight: nesColorBorderLight,
	nesColorBorderStrong: nesColorBorderStrong,
	nesColorBorderAlpha: nesColorBorderAlpha,
	nesColorBorderAlphaAlt: nesColorBorderAlphaAlt,
	nesColorBorderAlphaSubtle: nesColorBorderAlphaSubtle,
	nesColorBorderBrandPrimary: nesColorBorderBrandPrimary,
	nesColorBorderBrandSecondary: nesColorBorderBrandSecondary,
	nesColorBorderBrandSecondaryStrong: nesColorBorderBrandSecondaryStrong,
	nesColorBorderBrandNsGo: nesColorBorderBrandNsGo,
	nesColorBorderInfo: nesColorBorderInfo,
	nesColorBorderSuccess: nesColorBorderSuccess,
	nesColorBorderWarning: nesColorBorderWarning,
	nesColorBorderAlert: nesColorBorderAlert,
	nesColorFormLabel: nesColorFormLabel,
	nesColorFormBg: nesColorFormBg,
	nesColorFormVal: nesColorFormVal,
	nesColorFormValChecked: nesColorFormValChecked,
	nesColorFormPlaceholder: nesColorFormPlaceholder,
	nesColorFormHelptext: nesColorFormHelptext,
	nesColorFormChecked: nesColorFormChecked,
	nesColorFormBorder: nesColorFormBorder,
	nesColorFormBorderPressed: nesColorFormBorderPressed,
	nesColorFormError: nesColorFormError,
	nesColorFormIcon: nesColorFormIcon,
	nesColorDestructiveDefault: nesColorDestructiveDefault,
	nesColorDestructivePressed: nesColorDestructivePressed,
	nesColorFocusDefault: nesColorFocusDefault,
	nesColorFocusPressed: nesColorFocusPressed,
	nesColorFocusLight: nesColorFocusLight,
	nesColorButtonBrandText: nesColorButtonBrandText,
	nesColorButtonBrandBg: nesColorButtonBrandBg,
	nesColorButtonBrandBgPressed: nesColorButtonBrandBgPressed,
	nesColorButtonBrandFocus: nesColorButtonBrandFocus,
	nesColorButtonPrimaryText: nesColorButtonPrimaryText,
	nesColorButtonPrimaryBg: nesColorButtonPrimaryBg,
	nesColorButtonPrimaryBgPressed: nesColorButtonPrimaryBgPressed,
	nesColorButtonPrimaryInvertedText: nesColorButtonPrimaryInvertedText,
	nesColorButtonPrimaryInvertedBg: nesColorButtonPrimaryInvertedBg,
	nesColorButtonPrimaryInvertedBgPressed: nesColorButtonPrimaryInvertedBgPressed,
	nesColorButtonSecondaryText: nesColorButtonSecondaryText,
	nesColorButtonSecondaryBg: nesColorButtonSecondaryBg,
	nesColorButtonSecondaryBgPressed: nesColorButtonSecondaryBgPressed,
	nesColorButtonSecondaryInvertedText: nesColorButtonSecondaryInvertedText,
	nesColorButtonSecondaryInvertedBg: nesColorButtonSecondaryInvertedBg,
	nesColorButtonSecondaryInvertedBgPressed: nesColorButtonSecondaryInvertedBgPressed,
	nesColorButtonTertiaryText: nesColorButtonTertiaryText,
	nesColorButtonTertiaryTextPressed: nesColorButtonTertiaryTextPressed,
	nesColorButtonTertiaryBgPressed: nesColorButtonTertiaryBgPressed,
	nesColorButtonTertiaryInvertedText: nesColorButtonTertiaryInvertedText,
	nesColorButtonTertiaryInvertedBgPressed: nesColorButtonTertiaryInvertedBgPressed,
	nesColorRadioPanelBg: nesColorRadioPanelBg,
	nesColorRadioPanelBgChecked: nesColorRadioPanelBgChecked,
	nesColorStickerDefaultText: nesColorStickerDefaultText,
	nesColorStickerDefaultBorder: nesColorStickerDefaultBorder,
	nesColorStickerDefaultFilledText: nesColorStickerDefaultFilledText,
	nesColorStickerDefaultFilledBg: nesColorStickerDefaultFilledBg,
	nesColorStickerBrandText: nesColorStickerBrandText,
	nesColorStickerBrandBorder: nesColorStickerBrandBorder,
	nesColorStickerBrandFilledText: nesColorStickerBrandFilledText,
	nesColorStickerBrandFilledBg: nesColorStickerBrandFilledBg,
	nesColorStickerSubtleText: nesColorStickerSubtleText,
	nesColorStickerSubtleBorder: nesColorStickerSubtleBorder,
	nesColorStickerSubtleFilledText: nesColorStickerSubtleFilledText,
	nesColorStickerSubtleFilledBg: nesColorStickerSubtleFilledBg,
	nesColorStickerHighlightText: nesColorStickerHighlightText,
	nesColorStickerHighlightBg: nesColorStickerHighlightBg,
	nesColorStickerHighlightFilledText: nesColorStickerHighlightFilledText,
	nesColorStickerHighlightFilledBg: nesColorStickerHighlightFilledBg,
	nesColorStickerOfferText: nesColorStickerOfferText,
	nesColorStickerOfferBg: nesColorStickerOfferBg,
	nesColorStickerOfferFilledText: nesColorStickerOfferFilledText,
	nesColorStickerOfferFilledBg: nesColorStickerOfferFilledBg,
	nesColorToggleBg: nesColorToggleBg,
	nesColorToggleKnobBg: nesColorToggleKnobBg,
	nesColorHeroTextDark: nesColorHeroTextDark,
	nesColorHeroTextShadowLight: nesColorHeroTextShadowLight,
	nesColorHeroFlowLight: nesColorHeroFlowLight,
	nesColorHeroFlowDark: nesColorHeroFlowDark,
	nesColorMessageText: nesColorMessageText,
	nesColorMessageInlineBorder: nesColorMessageInlineBorder,
	nesColorMessageToastBg: nesColorMessageToastBg,
	nesColorMessageToastErrorBg: nesColorMessageToastErrorBg,
	nesColorBadgeDefaultBg: nesColorBadgeDefaultBg,
	nesColorBadgeDefaultText: nesColorBadgeDefaultText,
	nesColorBadgeBrandBg: nesColorBadgeBrandBg,
	nesColorBadgeBrandText: nesColorBadgeBrandText,
	nesColorBadgeAlertBg: nesColorBadgeAlertBg,
	nesColorBadgeAlertText: nesColorBadgeAlertText,
	nesColorBadgeSubtleBg: nesColorBadgeSubtleBg,
	nesColorBadgeSubtleText: nesColorBadgeSubtleText,
	nesColorBadgeSubtleInvertedBg: nesColorBadgeSubtleInvertedBg,
	nesColorBadgeSubtleInvertedText: nesColorBadgeSubtleInvertedText,
	nesColorBadgeSuccessBg: nesColorBadgeSuccessBg,
	nesColorBadgeSuccessText: nesColorBadgeSuccessText,
	nesColorTooltipBg: nesColorTooltipBg,
	nesColorTooltipText: nesColorTooltipText,
	nesColorChipcardInputBorderPressed: nesColorChipcardInputBorderPressed,
	nesColorListItemIcon: nesColorListItemIcon,
	nesColorLogoDefault: nesColorLogoDefault,
	nesColorLogoLight: nesColorLogoLight,
	nesColorExpandableText: nesColorExpandableText,
	nesColorExpandableTextPressed: nesColorExpandableTextPressed,
	nesColorExpandableBorder: nesColorExpandableBorder,
	nesColorExpandableInvertedText: nesColorExpandableInvertedText,
	nesColorExpandableInvertedTextPressed: nesColorExpandableInvertedTextPressed,
	nesColorExpandableInvertedBorder: nesColorExpandableInvertedBorder,
	nesColorFeatureTipBg: nesColorFeatureTipBg,
	nesColorTextListItemPrimary: nesColorTextListItemPrimary,
	nesColorBottomSheetBg: nesColorBottomSheetBg,
	nesColorHighlightBoxDefaultBg: nesColorHighlightBoxDefaultBg,
	nesColorHighlightBoxDefaultText: nesColorHighlightBoxDefaultText,
	nesColorHighlightBoxOfferBg: nesColorHighlightBoxOfferBg,
	nesColorHighlightBoxOfferText: nesColorHighlightBoxOfferText,
	nesColorHighlightBoxInfoBg: nesColorHighlightBoxInfoBg,
	nesColorHighlightBoxInfoText: nesColorHighlightBoxInfoText,
	nesColorHighlightBoxBrandBg: nesColorHighlightBoxBrandBg,
	nesColorHighlightBoxBrandText: nesColorHighlightBoxBrandText,
	nesColorRangeSliderBg: nesColorRangeSliderBg,
	nesColorRangeSliderBgPressed: nesColorRangeSliderBgPressed,
	nesColorRangeSliderFill: nesColorRangeSliderFill,
	nesColorRangeSliderMinmax: nesColorRangeSliderMinmax,
	nesColorRangeSliderKnobBg: nesColorRangeSliderKnobBg,
	nesColorRangeSliderKnobBorder: nesColorRangeSliderKnobBorder,
	nesColorRangeSliderKnobBorderPressed: nesColorRangeSliderKnobBorderPressed,
	nesAlphaWhite0: nesAlphaWhite0,
	nesAlphaWhite50: nesAlphaWhite50,
	nesAlphaWhite75: nesAlphaWhite75,
	nesAlphaWhite100: nesAlphaWhite100,
	nesAlphaWhite200: nesAlphaWhite200,
	nesAlphaWhite500: nesAlphaWhite500,
	nesAlphaBlack25: nesAlphaBlack25,
	nesAlphaBlack50: nesAlphaBlack50,
	nesAlphaBlack75: nesAlphaBlack75,
	nesAlphaBlack100: nesAlphaBlack100,
	nesAlphaBlack200: nesAlphaBlack200,
	nesAlphaBlack300: nesAlphaBlack300,
	nesAlphaBlack400: nesAlphaBlack400,
	nesAlphaBlack500: nesAlphaBlack500,
	nesSpacing1: nesSpacing1,
	nesSpacing2: nesSpacing2,
	nesSpacing3: nesSpacing3,
	nesSpacing4: nesSpacing4,
	nesSpacing5: nesSpacing5,
	nesSpacing6: nesSpacing6,
	nesSpacing8: nesSpacing8,
	nesSpacing10: nesSpacing10,
	nesSpacing12: nesSpacing12,
	nesSpacing14: nesSpacing14,
	nesSpacing16: nesSpacing16,
	nesSpacing20: nesSpacing20,
	nesSpacing24: nesSpacing24,
	nesSpacing32: nesSpacing32,
	nesBreakpointSm: nesBreakpointSm,
	nesBreakpointMd: nesBreakpointMd,
	nesBreakpointLg: nesBreakpointLg,
	nesBreakpointXl: nesBreakpointXl,
	nesMotionEaseDefault: nesMotionEaseDefault,
	nesMotionEaseIn: nesMotionEaseIn,
	nesMotionEaseOut: nesMotionEaseOut,
	nesMotionEaseInOut: nesMotionEaseInOut,
	nesMotionEaseInOutExpo: nesMotionEaseInOutExpo,
	nesMotionDurationXs: nesMotionDurationXs,
	nesMotionDurationDefault: nesMotionDurationDefault,
	nesMotionDurationMd: nesMotionDurationMd,
	nesMotionDurationLg: nesMotionDurationLg,
	nesMotionDurationXl: nesMotionDurationXl,
	nesMotionDuration2xl: nesMotionDuration2xl,
	nesMotionDuration3xl: nesMotionDuration3xl,
	nesShadowWebSm: nesShadowWebSm,
	nesShadowWebMd: nesShadowWebMd,
	nesShadowWebLg: nesShadowWebLg,
	nesShadowWebNavbar: nesShadowWebNavbar,
	nesShadowWebText: nesShadowWebText,
	nesShadowIosSmColor: nesShadowIosSmColor,
	nesShadowIosSmOffsetWidth: nesShadowIosSmOffsetWidth,
	nesShadowIosSmOffsetHeight: nesShadowIosSmOffsetHeight,
	nesShadowIosSmOpacity: nesShadowIosSmOpacity,
	nesShadowIosSmRadius: nesShadowIosSmRadius,
	nesShadowIosMdColor: nesShadowIosMdColor,
	nesShadowIosMdOffsetWidth: nesShadowIosMdOffsetWidth,
	nesShadowIosMdOffsetHeight: nesShadowIosMdOffsetHeight,
	nesShadowIosMdOpacity: nesShadowIosMdOpacity,
	nesShadowIosMdRadius: nesShadowIosMdRadius,
	nesShadowIosLgColor: nesShadowIosLgColor,
	nesShadowIosLgOffsetWidth: nesShadowIosLgOffsetWidth,
	nesShadowIosLgOffsetHeight: nesShadowIosLgOffsetHeight,
	nesShadowIosLgOpacity: nesShadowIosLgOpacity,
	nesShadowIosLgRadius: nesShadowIosLgRadius,
	nesShadowAndroidSmElevation: nesShadowAndroidSmElevation,
	nesShadowAndroidMdElevation: nesShadowAndroidMdElevation,
	nesShadowAndroidLgElevation: nesShadowAndroidLgElevation,
	nesFontFamily: nesFontFamily,
	nesFontSize2xs: nesFontSize2xs,
	nesFontSizeXs: nesFontSizeXs,
	nesFontSizeSm: nesFontSizeSm,
	nesFontSizeBase: nesFontSizeBase,
	nesFontSizeLg: nesFontSizeLg,
	nesFontSizeXl: nesFontSizeXl,
	nesFontSize2xl: nesFontSize2xl,
	nesFontSize3xl: nesFontSize3xl,
	nesFontSize4xl: nesFontSize4xl,
	nesFontSize5xl: nesFontSize5xl,
	nesFontSize6xl: nesFontSize6xl,
	nesFontSize7xl: nesFontSize7xl,
	nesFontSize8xl: nesFontSize8xl,
	nesFontSize9xl: nesFontSize9xl,
	nesFontSize10xl: nesFontSize10xl,
	nesFontWeightNormal: nesFontWeightNormal,
	nesFontWeightDemi: nesFontWeightDemi,
	nesFontWeightBold: nesFontWeightBold,
	nesFontStyleNormal: nesFontStyleNormal,
	nesFontStyleItalic: nesFontStyleItalic,
	nesFontLeadingNone: nesFontLeadingNone,
	nesFontLeadingCompressed: nesFontLeadingCompressed,
	nesFontLeadingTight: nesFontLeadingTight,
	nesFontLeadingNormal: nesFontLeadingNormal,
	nesFontLeadingRelaxed: nesFontLeadingRelaxed,
	nesFontLeadingLoose: nesFontLeadingLoose,
	nesFontTrackingNormal: nesFontTrackingNormal,
	nesFontTrackingTight: nesFontTrackingTight
};

export { tokens as t };
